import { UiStack } from '@experiences/ui-common';
import { PortalErrorPage } from '@uipath/portal-shell-react';
import React from 'react';
import { useIntl } from 'react-intl';

/**
 * The deny state for route guards that gate on permissions rather than on the URL being valid.
 * Pass it to {@link CheckGuardComponent} as `deny`, which otherwise falls back to `InvalidUrl` —
 * wrong here, because the address is fine and it is the caller who lacks the permission.
 */
export const Forbidden403: React.FC<{ 'data-cy'?: string }> = ({ 'data-cy': dataCy = 'route-forbidden' }) => {
    const { formatMessage: translate } = useIntl();

    return (
        <UiStack
            justify="center"
            align="center"
            data-cy={dataCy}
            style={{
                minHeight: '100%',
                width: '100%',
            }}>
            <PortalErrorPage
                type="403"
                buttonText={translate({ id: 'CLIENT_REFRESH_PAGE' })}
                buttonHref={globalThis.location.href} />
        </UiStack>
    );
};
